import * as React from "react";
import { singleton } from "logic/singleton";
const ViewContext = React.createContext(void 0);
export default singleton("contexts.SearchFiltersViewContext", () => ViewContext);
